import { Injectable } from '@angular/core'
import { Router } from '@angular/router'
import { INotificationHandler, INotificationView, UserAppNotificationService } from '@engineering11/notifications-web'
import { ICandidateAppliedNotification } from '../../model/app-notification.model'

@Injectable({ providedIn: 'root' })
export class CandidateAppliedNotificationHandler implements INotificationHandler<ICandidateAppliedNotification, INotificationView> {
  constructor(private router: Router, private userAppNotificationService: UserAppNotificationService) {}
  notificationType = 'candidate-applied'
  toViewModel(notification: ICandidateAppliedNotification): INotificationView {
    return {
      description: `A new application has been received for your job: ${notification.jobTitle}`,
      logoUrl: '',
      originalNotification: notification,
      title: 'New Application Received',
      viewed: notification.viewed,
    }
  }

  onClick(notification: ICandidateAppliedNotification): boolean | Promise<boolean> {
    if (!notification.viewed) {
      this.userAppNotificationService.markNotificationAsRead(notification.id)
    }
    return this.router.navigate(['/jobs/candidates/', notification.jobPostId], { queryParams: { candidateId: notification.candidateApplicationId } })
  }
}
